import React from "react";
import FlagIcon from "@mui/icons-material/Flag";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip, Tooltip } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

const noReasonsHeld = "Open the order to read why it needs a review.";
const noReasonsRecorded = "The order records no reason for the review.";

function describeReview(reasons?: string[]): string {
  if (reasons === undefined) return noReasonsHeld;
  return reasons.length > 0 ? reasons.join(" ") : noReasonsRecorded;
}

export function ReviewChip({
  inProgress,
  reasons,
  sx,
}: {
  inProgress?: boolean;
  reasons?: string[];
  sx?: SxProps<Theme>;
}) {
  const glyph = inProgress ? (
    <VisibilityIcon data-testid="review-glyph-in-progress" />
  ) : (
    <FlagIcon data-testid="review-glyph-flagged" />
  );

  return (
    <Tooltip title={describeReview(reasons)} describeChild>
      <Chip label="Needs review" color="warning" size="small" variant="outlined" icon={glyph} sx={sx} />
    </Tooltip>
  );
}
